import type {SocialNetworkSource} from '@src/Store/Slices/AppSlice/auth.slice';
import {MTN_HOSTNAME, isMtnSite} from './mtnConfig';

const DEFAULT_PROVIDERS: SocialNetworkSource[] = [
  'google',
  'apple',
  'facebook',
  'email',
];

const VODACOM_ONLY_PROVIDERS: SocialNetworkSource[] = ['vodacom'];
const MTN_ONLY_PROVIDERS: SocialNetworkSource[] = ['mtn'];

/**
 * Map hostname -> list of allowed auth providers for sign-in/sign-up.
 * Domains not listed fall back to DEFAULT_PROVIDERS.
 */
export const allowedAuthProvidersByDomain: Record<string, SocialNetworkSource[]> =
  {
    'vc.trace.plus': VODACOM_ONLY_PROVIDERS,
    [MTN_HOSTNAME]: MTN_ONLY_PROVIDERS,
  };

/**
 * Returns the list of allowed auth providers for the current hostname.
 * In SSR/build (no window), returns default providers. In browser, uses
 * hostname; supports dev override via ?vodacomOnly=1 or GATSBY_VODACOM_ONLY_DOMAIN_TEST=1,
 * and ?mtnOnly=1 or GATSBY_MTN_ONLY_DOMAIN_TEST=1.
 */
export function getAllowedAuthProviders(): SocialNetworkSource[] {
  if (typeof window === 'undefined') {
    return DEFAULT_PROVIDERS;
  }

  const url = new URL(window.location.href);
  const vodacomOnlyQuery = url.searchParams.get('vodacomOnly') === '1';
  const vodacomOnlyEnv =
    process.env.GATSBY_VODACOM_ONLY_DOMAIN_TEST === '1';
  if (vodacomOnlyQuery || vodacomOnlyEnv) {
    return VODACOM_ONLY_PROVIDERS;
  }
  if (isMtnSite()) {
    return MTN_ONLY_PROVIDERS;
  }

  const hostname = window.location.hostname;
  return allowedAuthProvidersByDomain[hostname] ?? DEFAULT_PROVIDERS;
}
